module.exports = __webpack_public_path__ + "img/39.9b81d9f5.png";